import { Box, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormatNumbers } from '../../../hooks/useFormatNumbers'
import { setSubTotal } from '../../../slices/orderSlice'
import { customStyles, spaceBetween } from '../../../styles'
import { RegularText } from '../../helpers'

export const InfoCilinder = () => {
  const { service, quantity, subTotal } = useSelector(state => state.order)
  const dispatch = useDispatch()
  const sTotal = useFormatNumbers(subTotal)
  useEffect(() => {
    service && dispatch(setSubTotal())
  }, [quantity, service, dispatch])
  
  return (
    <Stack spacing={3} mt={10}  sx={{ padding: 1, borderRadius: 1, backgroundColor: customStyles.colors.backgroundColor, boxShadow: customStyles.shadows.light }}>
      <RegularText text="Precio por cilindro" bold component={ <span>${service?.price} c/u</span> } sx={ spaceBetween }/>
      <RegularText text="Unidad" bold component={ <span>{ quantity }</span> } sx={ spaceBetween }/>
      <RegularText text="Subtotal" color={customStyles.colors.main} bold component={ <span>${sTotal}</span> } sx={ spaceBetween }/>
    </Stack>
  )
}
